import { useQuery } from "@tanstack/react-query";
import { fetchAssessmentIntakeForm } from "@/modules/third-party-risk/requests/intake-form-v2";
import { mapV2QuestionsToIntakeQuestions } from "../utils/map-v2-to-intake-question";

export function useAssessmentIntakeFormQuery(
  assessmentId: string | null,
) {
  return useQuery({
    queryKey: ["assessment-intake-form", assessmentId],
    queryFn: async () => {
      const data = await fetchAssessmentIntakeForm(assessmentId!);
      return {
        questions: mapV2QuestionsToIntakeQuestions(data.questions),
      };
    },
    enabled: !!assessmentId,
  });
}
